import { render, staticRenderFns } from "./Rates.vue?vue&type=template&id=3da0737c&scoped=true&"
import script from "./Rates.vue?vue&type=script&lang=js&"
export * from "./Rates.vue?vue&type=script&lang=js&"
import style0 from "./Rates.vue?vue&type=style&index=0&id=3da0737c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da0737c",
  null
  
)

export default component.exports